import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable , Subject, map } from 'rxjs';
import { IService } from '../interfaces/service/service';
import { environment } from 'src/environments/environment';
import { ServiceFilter } from 'src/app/pages/servicos/models/service-filter';
import { ServiceOrder } from 'src/app/pages/servicos/models/service-order';

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  formChanges = new Subject();
  filter = new ServiceFilter();
  order = new ServiceOrder();

  constructor(private http: HttpClient) {}
  
  getAll(page?: number, newFilters: string = '') {
    let urlParams = new URLSearchParams();
    if(this.filter?.name) {
      urlParams.append('name',this.filter.name);
    }
    if(page != null) {
      urlParams.append('page',String(page));
    }
    if(this.order?.professional) {
      urlParams.append('order[professional.name]', 'asc')
    }
    if(this.order?.name) {
      urlParams.append('order[name]', 'asc')
    }
    if(this.order?.specialty) {
      urlParams.append('order[specialty.name]', 'asc')
    }
    if(this.order?.value) {
      urlParams.append('order[value]', 'asc')
    }
    if(this.order?.transferValue) {
      urlParams.append('order[transferValue]', 'asc')
    }
    if(this.order?.percentValue) {
      urlParams.append('order[percentValue]', 'desc')
    }
    return this.http
      .get(`${environment.url}/services?${urlParams.toString()}${newFilters}`) as Observable<IService[]>;
  }


  save(req: IService) {
    return this.http.post(
      `${environment.url}/services`,
      req
    ) as Observable<IService>;
  }

  
  edit(req: IService, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(
      `${environment.url}/services/${id}`,
      req,
      { headers: headers }
    ) as Observable<IService>;
  }

  delete(id: number) {
    return this.http.delete(
      `${environment.url}/services/${id}`
    ) as Observable<IService>;
  }

  listenFormChanges() {
    return this.formChanges.asObservable();
  }

  setFilter(filter: ServiceFilter) {
    this.filter = filter;
  }
  setOrder(order: ServiceOrder) {
    this.order = order;
  }
}
